export default __webpack_public_path__ + "static/media/check_level.cdbdb279.svg";